import { makeObservable, observable, flow } from "mobx";
import { API } from "aws-amplify";
import { getLogs } from "../../graphql/queries";

class AuditLogStore {
  account = null;
  
  auditLogs = [];
  totalRowCount = 0;

  search = '';
  sorting = [];
  pagination = {
    pageIndex: 0,
    pageSize: 10
  };

  modalStore= null;
  
  isLoading = false;
  
  constructor({ customer, modalStore }) {
    makeObservable(this, {
      account: observable,
      auditLogs: observable,
      totalRowCount: observable,
      isLoading: observable,
      fetchAuditLogs: flow,
    });
    
    this.account = customer;
    this.modalStore = modalStore;
    
    void this.fetchAuditLogs();
  }
  
  async getLogs(parameters) {
    const response = await API.graphql({
      query: getLogs,
      variables: {
        input: {
          account: this.account,
          topic: "conversation_event",
          parameters: JSON.stringify(parameters),
        },
      },
      authMode: "AMAZON_COGNITO_USER_POOLS",
    });

    const responseBody = JSON.parse(response.data.getLogs.body);
    return { items: responseBody.items || [], nextPage: responseBody.next_page };
  }
  
  *fetchAuditLogs() {
    try {
      this.isLoading = true;
      this.isError = false;

      const parameters = {
        count_records: false,
        page_size: this.pagination.pageSize,
        page: this.pagination.pageIndex + 1,
      };

      if (this.search && this.search.trim()) {
        parameters.search = this.search.trim();
      }

      if (this.sorting && this.sorting.length > 0) {
        parameters.order_by = {
          id: 'insert_date',
          desc: this.sorting[0]?.desc || false
        }
      }

      if (parameters.page === 1) {
        parameters.count_records = true;
      }

      const { items, nextPage } = yield this.getLogs(parameters);
      
      this.auditLogs = items.map((log) => ({
        ...log,
        insert_date: new Date(log?.insert_date).toISOString(),
      }));

      this.totalRowCount = nextPage === null ? items.length : this.totalRowCount;

    } catch (error) {
      this.modalStore.setup({
        modal: "generalMessageModal",
        title: "Opps!",
        message: "Error trying get logs"
      });
    } finally {
      this.isLoading = false;
    }
  }
}

export default AuditLogStore;
